import { render, staticRenderFns } from "./ReporteMTTRMTBFMensual.vue?vue&type=template&id=2387590a&"
import script from "./ReporteMTTRMTBFMensual.vue?vue&type=script&lang=js&"
export * from "./ReporteMTTRMTBFMensual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports